import { render } from "./dashboard.vue?vue&type=template&id=46c07cd2?v=1.4"
import script from "./dashboard.vue?vue&type=script&lang=js?v=1.4"
export * from "./dashboard.vue?vue&type=script&lang=js?v=1.4"

import exportComponent from "/Users/vladbiletski/Documents/Work/apps/dev/qt-lite-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__